module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "center",
    attrs: {
      "id": "start"
    }
  }, [_c('b', {
    staticClass: "sans_bold"
  }, [_vm._v("WATCHERS")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_c('b', {
    staticClass: "sans_normal"
  }, [_vm._v("Case File: 7222")])])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', {
    staticClass: "sans_normal"
  }, [_vm._v("Name: Samuel Hughes")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', {
    staticClass: "sans_normal"
  }, [_vm._v("Age: 13")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', {
    staticClass: "sans_normal"
  }, [_vm._v("First Contact: 41.33.02")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('b', {
    staticClass: "sans_normal"
  }, [_vm._v("Acceptance: Yes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5909bdc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/4start.vue
// module id = 63
// module chunks = 0